import React, { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { ErrorBoundary as CommonErrorBoundary } from '@atlassian/search-common';
import { SearchDialog } from '@atlassian/search-dialog';
import { ReadingAidsContainer, ReadingAidsPopupContainer } from '../ai-answer-dialog/styled';
import { logger } from '../common';
import { DEFAULT_GAS_CHANNEL } from '../constants';
import { messages } from './messages';
import { ErrorBoundaryFallbackText } from './styled';
/**
 *	@private
 *	@deprecated Use the ErrorBoundary in common instead
 *	TODO Rewrite to use the error boundry from common
 */
export var ErrorBoundary = function ErrorBoundary(_ref) {
  var isReadingAids = _ref.isReadingAids,
    wrapper = _ref.wrapper,
    source = _ref.source,
    children = _ref.children;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var DefaultWrapper = isReadingAids ? function (props) {
    return /*#__PURE__*/React.createElement(ReadingAidsPopupContainer, null, /*#__PURE__*/React.createElement(ReadingAidsContainer, null, props.children));
  } : SearchDialog;
  var Wrapper = wrapper ? wrapper : DefaultWrapper;
  var logError = useCallback(function (error) {
    var _error$stack;
    // Currently we are in between deprecating UFOv1 and adopting react-UFO  for platform packages, so this is a temporary way for us to collect error logs
    // https://atlassian.slack.com/archives/C01AY8132S3/p1716509785878689
    var errorAttributes = {
      errorName: error.name,
      errorMessage: error.message,
      errorStack: (_error$stack = error.stack) === null || _error$stack === void 0 ? void 0 : _error$stack.split('\n').at(1)
    };
    createAnalyticsEvent({
      action: 'failed',
      actionSubject: 'aiAnswerDialog',
      source: source || 'unknown',
      eventType: 'track',
      attributes: errorAttributes
    }).fire(DEFAULT_GAS_CHANNEL);
    logger.error(errorAttributes);
  }, [source, createAnalyticsEvent]);
  return /*#__PURE__*/React.createElement(CommonErrorBoundary, {
    fallback: /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ErrorBoundaryFallbackText, {
      isReadingAids: isReadingAids
    }, formatMessage(messages.error_boundary_fallback_text))),
    onException: logError
  }, children);
};